import {
  type ContentItemsFilter,
  type ContentItemsFilterServer,
  type ListContentItemsParams,
  type ListContentItemsStatusItem,
  makeQueryString,
  parseLimit,
} from '@metapic-apps/shared'

const handleFilter = (filter: ContentItemsFilter): ContentItemsFilterServer => {
  const processedFilter: ContentItemsFilterServer & ContentItemsFilter = { ...filter }

  delete processedFilter.campaign
  delete processedFilter.creator
  delete processedFilter.createdByMe
  delete processedFilter.contentTypes
  delete processedFilter.profileRef
  delete processedFilter.profileId

  if (filter.creator) {
    processedFilter.creatorIds = [filter.creator.id]
  }

  if (filter.campaign) {
    processedFilter.campaignIds = [filter.campaign.id]
  }
  if (filter.contentTypes?.length) {
    processedFilter.type = filter.contentTypes
  }

  if (filter.profileId) {
    processedFilter.profileIds = [filter.profileId]
  } else if (filter.profileRef) {
    processedFilter.profileRefs = [filter.profileRef]
  }

  return processedFilter
}

export const makeQueryStringForContentItems = (filter: ContentItemsFilter): string | null => {
  return makeQueryString(handleFilter(filter), true)
}

export const handleContentItemFilter = (filter: ContentItemsFilter): ListContentItemsParams => {
  const params: ListContentItemsParams = {}

  if (filter.page !== undefined) {
    params.page = filter.page
  }

  const limit = parseLimit(filter.limit ?? filter.size)
  if (limit !== undefined) {
    params.limit = limit
  }

  if (filter.advertiser) {
    params.advertiser_ids = [filter.advertiser.id]
  }

  if (filter.creator) {
    params.creator_ids = [filter.creator.id]
  }

  if (filter.campaign) {
    params.campaign_ids = [filter.campaign.id]
  }

  const dateFrom = filter.dateFrom ?? filter.startDate
  if (dateFrom) {
    params.date_from = dateFrom
  }

  const dateTo = filter.dateTo ?? filter.endDate
  if (dateTo) {
    params.date_to = dateTo
  }

  if (filter.contentTypes?.length) {
    params.type = filter.contentTypes
  }

  if (filter.sortBy) {
    params.sort_by = filter.sortBy
  }

  if (filter.status) {
    params.status = [filter.status] as ListContentItemsStatusItem[]
  }

  if (filter.profileId) {
    params.profile_ids = [filter.profileId]
  } else if (filter.profileRef) {
    params.profile_refs = [filter.profileRef]
  }

  return params
}
